export default __webpack_public_path__ + "static/logo-a1e85c300c910ac54453f00023e00109.png";